/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { MetricCard } from './components/MetricCard';

const Publisher = ({ dateFrom$, dateTo$ }) => {
  const timePeriod = useMemo(
    () => ({ from: dateFrom$.value, to: dateTo$.value }),
    [dateFrom$.value, dateTo$.value],
  );

  return (
    <>
      <MetricCard type='ApplicationsPublisher' timePeriod={timePeriod} />
    </>
  );
};

const Advertiser = ({ dateFrom$, dateTo$ }) => {
  const timePeriod = useMemo(
    () => ({ from: dateFrom$.value, to: dateTo$.value }),
    [dateFrom$.value, dateTo$.value],
  );
  return (
    <>
      <MetricCard type='Applications' timePeriod={timePeriod} />
      <MetricCard type='Campaigns' timePeriod={timePeriod} />
      <MetricCard type='Events/Installs Ratio' timePeriod={timePeriod} />
      <MetricCard type='Top Events' timePeriod={timePeriod} />
    </>
  );
};

export const PerformanceSection = {
  Publisher,
  Advertiser,
};
